// extracted by mini-css-extract-plugin
export default {"red":"Text_red__Oscfn"};